(function () {
  'use strict';

  if (window.__cduUpsellBound) return;
  window.__cduUpsellBound = true;

  var SUCCESS_TIMEOUT_MS = 2000;
  var DISCOUNT_CODE = 'FREEDNA';

  function applyDiscountCode(code) {
    return fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin'
    }).catch(function (err) {
      console.warn('CDU upsell: failed to apply discount ' + code + ':', err);
    });
  }

  function cartContainsVariant(variantId) {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return false;
        return cart.items.some(function (line) {
          return parseInt(line.variant_id, 10) === parseInt(variantId, 10);
        });
      })
      .catch(function () { return false; });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-cdu-upsell-add]');
    if (!btn) return;

    event.preventDefault();

    if (btn.hasAttribute('disabled')) return;
    btn.setAttribute('disabled', 'disabled');

    var card = btn.closest('[data-cdu-upsell]');
    var variantId = btn.getAttribute('data-variant-id');
    var sellingPlan = btn.getAttribute('data-selling-plan');
    var welcomeKitVariant = btn.getAttribute('data-welcome-kit-variant');
    var discountCode = btn.getAttribute('data-discount-code') || DISCOUNT_CODE;
    if (!variantId) {
      btn.removeAttribute('disabled');
      return;
    }

    var membershipItem = { id: parseInt(variantId, 10), quantity: 1 };
    if (sellingPlan) membershipItem.selling_plan = parseInt(sellingPlan, 10);

    var cartDrawer = document.querySelector('cart-drawer');

    // Welcome Kit is auto-discounted to FREE by the Myoform Bundle Discount
    // Shopify Function whenever a membership line is in the cart. Only add it
    // if it isn't already in the cart, otherwise we'd bump the qty to 2.
    var welcomeKitCheck = welcomeKitVariant
      ? cartContainsVariant(welcomeKitVariant)
      : Promise.resolve(true);

    welcomeKitCheck
      .then(function (alreadyHasWelcomeKit) {
        var items = [membershipItem];
        if (welcomeKitVariant && !alreadyHasWelcomeKit) {
          var welcomeKitId = parseInt(welcomeKitVariant, 10);
          if (welcomeKitId) items.push({ id: welcomeKitId, quantity: 1 });
        }

        var body = { items: items };
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        return applyDiscountCode(discountCode).then(function () {
          return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(body)
          });
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error((data && (data.description || data.message)) || 'Cart error');
          }
          return data;
        });
      })
      .then(function (data) {
        if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          window.publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cdu-upsell',
            productVariantId: variantId,
            cartData: data
          });
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          if (cartDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.remove('is-empty');
          }
          cartDrawer.renderContents(data);
          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open(btn);
          }
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }

        if (card) {
          btn.classList.add('cdu-upsell__add--success');
          var originalHTML = btn.innerHTML;
          btn.innerHTML =
            '<span class="cdu-upsell__add-icon" aria-hidden="true">' +
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">' +
                '<path d="M3.5 8.5L6.5 11.5L12.5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</span>' +
            '<span>Added</span>';
          btn.setAttribute('aria-label', 'Added to cart');

          setTimeout(function () {
            btn.classList.remove('cdu-upsell__add--success');
            btn.innerHTML = originalHTML;
            btn.setAttribute('aria-label', 'Add Myoform Monthly Membership to cart');
            btn.removeAttribute('disabled');
          }, SUCCESS_TIMEOUT_MS);
        } else {
          btn.removeAttribute('disabled');
        }
      })
      .catch(function (err) {
        console.error('CDU upsell add error:', err);
        btn.removeAttribute('disabled');
        if (err && err.message) {
          alert(err.message);
        }
      });
  });
})();
